import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Theme } from '@mui/material';
import { SxProps } from '@mui/system';

type NotFoundRowProps = {
  colSpan?: number;
  message?: string;
  tableCellSx?: SxProps<Theme>;
};

const NotFoundRow: FC<NotFoundRowProps> = ({
  colSpan,
  message,
  tableCellSx
}) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell colSpan={colSpan} align='center' sx={tableCellSx}>
        {message || t('common.table.resultsNotFound')}
      </TableCell>
    </TableRow>
  );
};

export default NotFoundRow;
